module.exports = __webpack_public_path__ + "img/wk3.67de08ba.png";